import React from "react";
import { Box, LinearProgress, Typography } from "@mui/material";

export default function Loading({ message = "Loading..." }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(255, 255, 255, 0.85)",
        zIndex: 1300,
        px: 3,
      }}
    >
      <Typography sx={{ mb: 2, textAlign: "center", maxWidth: 420 }} variant="body1" color="text.secondary">
        {message}
      </Typography>
      <LinearProgress sx={{ width: "min(320px, 90vw)" }} />
    </Box>
  );
}